/* Small formatting helpers, ported verbatim from artifact.html. */

export const $ = id => document.getElementById(id);
export const fmt = n => Number(n).toLocaleString("en-IN");
export const esc = s => String(s).replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
export const scase = t => { t = String(t).replace(/_/g, " "); return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase(); };
export const shortDate = ts => new Date(ts).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
